<template>
  <h1
    :class="customClass"
    v-if="level === 1"
  >
    <slot />
  </h1>
  <h2
    :class="customClass"
    v-else-if="level === 2"
  >
    <slot />
  </h2>
  <h3
    :class="customClass"
    v-else-if="level === 3"
  >
    <slot />
  </h3>
  <h4
    :class="customClass"
    v-else-if="level === 4"
  >
    <slot />
  </h4>
  <h5
    :class="customClass"
    v-else-if="level === 5"
  >
    <slot />
  </h5>
  <h6
    :class="customClass"
    v-else-if="level === 6"
  >
    <slot />
  </h6>
</template>

<script lang="ts">
export default {
  props: {
    level: {
      type: Number,
      default: 2,
      validator: (value: number) => [1, 2, 3, 4, 5, 6].includes(value),
    },
    customClass: {
      type: String,
      default: ''
    },
  },
}
</script>